<template>
  <div class="w-full max-w-sm border border-border rounded-ds-lg p-5">
    <TimelineHandler>
      <template #default="{ timeline, handleUpdateTimeline }">
        <PeriodScrollerSettings
          :timeline
          :disabled
          simple-view
          @apply="handleApply($event, timeline, handleUpdateTimeline)"
        />
      </template>
    </TimelineHandler>
  </div>
</template>

<script setup lang="ts">
import type { RepositoryTimeline, TimelineDraft } from '@types'

import PeriodScrollerSettings from '@ds/patterns/PeriodScroller/PeriodScrollerSettings.vue'
import TimelineHandler from '../Timeline/TimelineHandler.vue'

type Props = {
  disabled?: boolean
}

defineProps<Props>()

const handleApply = async (
  draft: TimelineDraft, 
  timeline: RepositoryTimeline, 
  callback: (draft: RepositoryTimeline, isEndChanged: boolean) => Promise<void>
) => {
  const isEndChanged =
    draft.end !== timeline.end || draft.end_is_today !== timeline.end_is_today
  callback({
    ...timeline,
    ...draft,
  }, isEndChanged)
}
</script>
